import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Col, Row } from "antd";
import { getRequest, postRequest } from "../../../axios";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import SearchIcon from "../../../image/SearchIcon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";

const { Search } = Input;

const ArchivedpurchasedSubscriptionList = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [
    archivedPurchasedSubscriptionList,
    setArchivedPurchasedSubscriptionList,
  ] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getPurchasedSubscriptionArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("material-master-archive/", state);
        if (apiResponse.data.results.success) {
          setArchivedPurchasedSubscriptionList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archived_purchase_subscription"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPurchasedSubscriptionArchiveList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company";
    }
    if (sortField === "subscription" && sortOrder === "ascend") {
      sortingEnumKey = "subscription";
    }
    if (sortField === "subscription" && sortOrder === "descend") {
      sortingEnumKey = "-subscription";
    }

    if (sortField === "payment_mode" && sortOrder === "ascend") {
      sortingEnumKey = "payment_mode";
    }
    if (sortField === "payment_mode" && sortOrder === "descend") {
      sortingEnumKey = "-payment_mode";
    }

    if (sortField === "active" && sortOrder === "ascend") {
      sortingEnumKey = "active";
    }
    if (sortField === "active" && sortOrder === "descend") {
      sortingEnumKey = "-active";
    }

    if (sortField === "start_date" && sortOrder === "ascend") {
      sortingEnumKey = "start_date";
    }
    if (sortField === "start_date" && sortOrder === "descend") {
      sortingEnumKey = "-start_date";
    }

    if (sortField === "end_date" && sortOrder === "ascend") {
      sortingEnumKey = "end_date";
    }
    if (sortField === "end_date" && sortOrder === "descend") {
      sortingEnumKey = "-end_date";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("material-master-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          t("purchased_subscription_restore_successfully")
        );
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_restore_purchased_subscription"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "COMPANY",
      dataIndex: "company",
      key: "company",
      sorter: true,
    },
    {
      title: "SUBSCRIPTION",
      dataIndex: "subscription",
      key: "subscription",
      sorter: true,
    },
    {
      title: "PAYMENT MODE",
      dataIndex: "payment_mode",
      key: "payment_mode",
      sorter: true,
    },
    {
      title: "ACTIVE",
      dataIndex: "active",
      key: "active",
      sorter: true,
    },
    {
      title: "START DATE",
      dataIndex: "start_date",
      key: "start_date",
      sorter: true,
    },
    {
      title: "END DATE",
      dataIndex: "end_date",
      key: "end_date",
      sorter: true,
    },

    {
      title: "ACTION",
      key: "operation",
      render: (text, record) => (
        <Space>
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />{" "}
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("archived_purchased_subscription")}</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/purchased-subscription">
                  {t("purchasedSubscriptionList")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>
              {t("archived_purchased_subscription")}
            </h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>

          <Col>
            <Table
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              columns={columns}
              dataSource={archivedPurchasedSubscriptionList}
              scroll={{ x: 800 }}
              loading={loading}
              pagination={{
                defaultCurrent: state.page,
                defaultPageSize: state.pagesize,
                total: totalCount,
                showSizeChanger: true,
                showTotal: (totalCount) => `Total ${totalCount} items`,
              }}
              onChange={handleTableChange}
            />
          </Col>
        </div>
      </section>
    </>
  );
};

export default ArchivedpurchasedSubscriptionList;
